import { type FC } from 'react'
import { Icon } from '@atoms'

const SIZE = 26
const BORDER = '#FFF'
const ICON_NAME = 'info'

export type HighlightDotMarkerProps = {
    /** X coordinate (chart space) */
    cx: number
    /** Y coordinate (chart space) */
    cy: number
    /** Fill color for the circle (e.g. line/meter color) */
    lineColor: string
    /** Unique id for the SVG filter to avoid collisions when many markers are rendered */
    filterId: string
}

/**
 * Marker for interval chart highlight points: circle with drop shadow and info icon.
 * Renders inside Recharts SVG; uses foreignObject + Icon for the "i" (project standard).
 */
export const HighlightDotMarker: FC<HighlightDotMarkerProps> = (props) => {
    const { cx, cy, lineColor, filterId } = props
    const half = SIZE / 2

    return (
        <g>
            <defs>
                <filter
                    id={filterId}
                    x="-50%"
                    y="-50%"
                    width="200%"
                    height="200%"
                >
                    <feDropShadow
                        dx={0}
                        dy={4}
                        stdDeviation={1.5}
                        floodColor="rgba(0,0,0,0.07)"
                    />
                    <feDropShadow
                        dx={0}
                        dy={2}
                        stdDeviation={1}
                        floodColor="rgba(0,0,0,0.06)"
                    />
                </filter>
            </defs>
            <g filter={`url(#${filterId})`}>
                <circle
                    cx={cx}
                    cy={cy}
                    r={half - 1}
                    fill={lineColor}
                    stroke={BORDER}
                    strokeWidth={2}
                />
                <foreignObject
                    x={cx - half}
                    y={cy - half}
                    width={SIZE}
                    height={SIZE}
                >
                    <div className="flex h-full w-full items-center justify-center text-white">
                        <Icon
                            name={ICON_NAME}
                            size="xsmall"
                            className="text-white"
                        />
                    </div>
                </foreignObject>
            </g>
        </g>
    )
}
